import { EventAvailableOutlined, FilterListOutlined } from '@mui/icons-material';
import { List, ListItemIcon, ListItemText } from '@mui/material';
import { NavCollapse, NavDrawerProps, NavSubListItem } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';

import { NavId, UserDomainType } from '~/common/types';
import { FiltersNavList } from '~/components/FiltersNavList/FiltersNavList';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { RouteId } from '~/routes/RouteId';

export const UserAvailabilityListDrawer = (props: NavDrawerProps) => {
  return (
    <NavDrawerSimple navId={NavId.team} {...props}>
      <List disablePadding sx={{ marginBottom: 4 }}>
        <NavSubListItem component={Link} to={RouteId.team} selected={!!useMatch({ path: RouteId.team, end: true })}>
          <ListItemIcon>
            <EventAvailableOutlined />
          </ListItemIcon>
          <ListItemText primary={<Trans i18nKey={`Nav.${NavId.teamAvailabilities}`} />} />
        </NavSubListItem>
      </List>

      <NavCollapse
        in
        label={<Trans i18nKey="FilterSelect.label" />}
        sx={{ marginBottom: 4 }}
        icon={<FilterListOutlined />}
      >
        <List>
          <FiltersNavList domain={UserDomainType.USER_AVAILABILITY} showDot />
        </List>
      </NavCollapse>
    </NavDrawerSimple>
  );
};
